module.exports = __webpack_public_path__ + "media/images/new_kitchen-92da14d1.webp";